import React from "react";
import { TONES, statusTone, statusLabel } from "./statusMap";
import "./Badge.scss";

// Fontaine M22 — Badge: compact status / count pill (V2 `badge-*`): soft tinted fill, tinted hairline,
// tinted text. Pass `status` to get the tone from the status map, or `tone` directly.

const LEGACY_TONES = { default: "muted", purple: "accent" };

/**
 * @param {"accent"|"success"|"warning"|"danger"|"muted"|"info"} [tone="muted"]
 * @param {string} [status]        business status → tone + sentence-case label (children override the label)
 * @param {"sm"|"md"} [size="md"]
 * @param {boolean} [dot]          leading status dot
 * @param {boolean} [count]        numeric badge (tabular, min-width)
 */
export default function Badge({ children, tone, status, size = "md", dot = false, count = false, className = "", ...rest }) {
  const resolved = status ? statusTone(status) : TONES.includes(tone) ? tone : LEGACY_TONES[tone] || "muted";
  const label = children ?? (status ? statusLabel(status) : null);
  const classes = ["ft-badge", `ft-badge--${resolved}`, `ft-badge--${size === "sm" ? "sm" : "md"}`, count ? "ft-badge--count" : "", className].filter(Boolean).join(" ");
  return (
    <span className={classes} data-status={status || undefined} {...rest}>
      {dot ? <span className="ft-badge__dot" aria-hidden="true" /> : null}
      {label}
    </span>
  );
}
